module.exports = __webpack_public_path__ + "static/media/AXISBANK_F1.86717f3f.txt";